var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center"},[_c('div',{staticClass:"logo"}),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.$store.getters.schoolData.Name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }